import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import Table from 'rc-table';
import { WorkflowTaskActionsContainer } from './WorkflowTaskActionsContainer';
import { FormField } from '../../../components/FormFields';
import { selectConfig } from '../../Api/selectors';
import { HBox, VBox } from '../../../components/Box';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const Container = styled.div`
  width: 100%;
  background: white;
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;

class WorkflowTasksSectionComp extends BaseComponent {
  get tasks() {
    return this.props.tasks ?? [];
  }

  getData = t => {
    return {
      name: t.name,
      vehiclePurposes: t.vehiclePurposes.join('  |  '),
      actions: t,
      tasks: this.tasks,
      task: t,
    };
  };

  getColumns = props => {
    const columns = [
      { title: 'Taak naam', dataIndex: 'name', key: 'name', align: 'left' },
      { title: 'Voertuigtype', dataIndex: 'vehiclePurposes', key: 'vehiclePurposes', align: 'left' },
    ];
    const actionsColumn = {
      key: 'actions',
      dataIndex: 'actions',
      render(value, row, index) {
        return <WorkflowTaskActionsContainer task={value} tasks={row.tasks} removeTask={props.removeTask} />;
      },
    };

    if (!this.props.disabled) columns.push(actionsColumn);

    return columns;
  };

  onClickEdit(record) {
    this.setState({ renderEdit: true, editTask: record.task });
  }

  get confirmEditBtnDisabled() {
    return !this.state.editTask.name || this.props.disabled;
  }

  editTask() {
    this.props.editTask(this.state.editTask.id, this.state.editTask);
  }

  get availableVehiclePurposes() {
    const fromConfig = (this.props.config?.configJSON?.vehicle_purposes ?? []).map(p => p.vehicle_purpose);
    const defaultPurposes = [
      'passenger',
      'commercial',
      'Trekker',
      'Bakwagen',
      'Oplegger',
      'Aanhangwagen',
      'Landbouw- of bosbouwtrekker',
      'Motorfiets' ,
      'Bromfiets',
      'Klein materieel (binnenopslag) per m2',
      'Klein/middelgroot materieel buitenopslag <6m2',
      'Groot & afwijkend materieel buitenopslag >6m2',
      'chassiscabine_less_3500',
      'chassiscabine_greater_3500',
      'motor',
      'oplegger',
      'aanhanger',
    ];

    // TODO refactor return only fromConfig after IDWE-2829 merged
    return fromConfig.length ? fromConfig : defaultPurposes;
  }

  toggleVehiclePurpose(purpose) {
    const currentPurposes = this.state.editTask.vehiclePurposes;
    let newPurposes = [];
    if (currentPurposes.includes(purpose)) newPurposes = currentPurposes.filter(p => p !== purpose);
    if (currentPurposes.includes('*')) newPurposes = this.availableVehiclePurposes.filter(p => p !== purpose);
    if (!currentPurposes.includes(purpose) && !currentPurposes.includes('*')) newPurposes = [...currentPurposes, purpose];

    this.setState(prev => ({ editTask: { ...prev.editTask, vehiclePurposes: newPurposes } }));
  }

  renderPurposesSection(task) {
    return (
      <VBox>
        {this.availableVehiclePurposes.map(p => (
          <CheckboxComponent
            label={p}
            checked={task.vehiclePurposes.includes(p) || task.vehiclePurposes.includes('*')}
            onChange={() => this.toggleVehiclePurpose(p)}
          />
        ))}
      </VBox>
    );
  }

  renderEditModal() {
    if (!this.state.renderEdit) return '';

    return (
      <ModalComponent
        onClose={this.setStateFn({ renderEdit: false, editTask: null })}
        title={this.lbl(`workflows.details.tasks.editModalTitle`)}
      >
        <VBox>
          <FormField>
            <input
              name="newTaskName"
              value={this.state.editTask.name ?? ''}
              onChange={evt => this.setState(prev => ({ editTask: { ...prev.editTask, name: evt.target.value } }))}
            />
          </FormField>
          {this.renderPurposesSection(this.state.editTask)}
        </VBox>

        <HBox right>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.setStateFn({ renderEdit: false, editTask: null })}>
            {this.lbl('cancel')}
          </ButtonComponent>
          <ButtonComponent
            style={'ButtonSoftEdit'}
            onClick={() => {
              this.editTask();
              this.setState({ renderEdit: false, editTask: null });
            }}
            disabled={this.confirmEditBtnDisabled}
            primary
          >
            {this.lbl('confirm')}
          </ButtonComponent>
        </HBox>
      </ModalComponent>
    );
  }

  render() {
    const columns = this.getColumns({ removeTask: this.props.removeTask });
    const data = this.tasks?.map(t => this.getData(t));

    return (
      <Container>
        <CustomTable
          columns={columns}
          data={data}
          scroll={{ x: window.innerWidth < 975 ? 975 : false }}
          emptyText={'Geen taken toegevoegd'}
          onRow={(record, index) => {
            return {
              onClick: () => this.onClickEdit(record),
            };
          }}
        />
        {this.renderEditModal()}
      </Container>
    );
  }
}

WorkflowTasksSectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WorkflowTasksSection = compose(withConnect, withRouter)(WorkflowTasksSectionComp);
